import React from 'react';
import Image from 'components/AppImage';
import Icon from 'components/AppIcon';

const ImageCard = ({ image, onImageClick, index }) => {
  const handleClick = () => {
    onImageClick(image, index);
  };

  return (
    <div 
      className="group relative overflow-hidden rounded-lg shadow-organic hover:shadow-organic-lg transition-organic cursor-pointer hover-lift"
      onClick={handleClick}
    >
      <div className="relative">
        <Image
          src={image?.src}
          alt={image?.alt}
          className="w-full h-auto object-cover"
          loading="lazy"
        />
        
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-organic">
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <h3 className="text-white font-medium text-sm mb-1">{image?.title}</h3>
            {image?.location && (
              <p className="text-white/80 text-xs flex items-center">
                <Icon name="MapPin" size={12} className="mr-1" />
                {image?.location}
              </p>
            )}
          </div>
        </div>

        {/* View Icon */}
        <div className="absolute top-2 right-2 w-8 h-8 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-organic">
          <Icon name="Eye" size={16} className="text-white" />
        </div>

        {/* Category Badge */}
        <div className="absolute top-2 left-2">
          <span className="px-2 py-1 bg-primary/90 text-primary-foreground text-xs rounded-md font-medium">
            {image?.category}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ImageCard;